@layer chart {
  .menu {
    z-index: var(--z-index-app-header);
    box-shadow: var(--elevation-moderate);
    border-radius: 4px;
    outline: 1px solid var(--border-soft);
    background-color: var(--surface-default);
  }

  .menuItem {
    z-index: var(--z-index-app-header);
    outline: 0;
  }
}
